var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCalendarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7670_65795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.475 3.39941H5.84303C6.11171 3.39941 6.32829 3.18064 6.32829 2.90925V0.682783C6.32829 0.411397 6.11171 0.192627 5.84303 0.192627H4.475C4.20633 0.192627 3.98975 0.411397 3.98975 0.682783V2.90925C3.98975 3.18064 4.20633 3.39941 4.475 3.39941Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3187 3.39941H13.6868C13.9555 3.39941 14.172 3.18064 14.172 2.90925V0.682783C14.172 0.411397 13.9555 0.192627 13.6868 0.192627H12.3187C12.0501 0.192627 11.8335 0.411397 11.8335 0.682783V2.90925C11.8335 3.18064 12.0501 3.39941 12.3187 3.39941Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 1.82104H15.0933V2.90936C15.0933 3.69305 14.4627 4.32998 13.6869 4.32998H12.3188C11.543 4.32998 10.9124 3.69305 10.9124 2.90936V1.82104H7.24695V2.90936C7.24695 3.69305 6.6164 4.32998 5.84054 4.32998H4.47251C3.69665 4.32998 3.06609 3.69305 3.06609 2.90936V1.82104H2.75904C1.35262 1.82104 0.201172 2.97859 0.201172 4.40475V15.1051C0.201172 16.5257 1.34988 17.6888 2.75904 17.6888H15.3976C16.804 17.6888 17.9554 16.5285 17.9554 15.1051V4.40475C17.9554 2.97859 16.8067 1.82104 15.4003 1.82104ZM16.2584 15.1023C16.2584 15.5786 15.8691 15.9691 15.4003 15.9691H2.76178C2.29023 15.9691 1.90367 15.5759 1.90367 15.1023V6.53983H16.2612V15.1023H16.2584Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0444 10.3074H10.0354V8.08179H8.39927V10.3074H6.39021V11.8112H8.39927V14.0368H10.0354V11.8112H12.0444V10.3074Z",
    fill: "#848484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7670_65795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8649,
    height: 17.8649,
    fill: "white",
    transform: "translate(0.134766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCalendarToggle);
export default __webpack_public_path__ + "static/media/add-to-calendar-toggle.ef2b2407d1c32c214581578b18ea19c0.svg";
export { ForwardRef as ReactComponent };